import { animated, easings, useTransition, useSpring } from '@react-spring/web';
import React, { useEffect, useRef, useState } from 'react';
import { useWindowSize } from '../utils/hooks/use-window-size';

export const MobileTray = ({ isVisible, setIsVisible, backgroundOverlay, children, hidePullTab }) => {
  const prevTouchMove = useRef();
  const [currentTouchMove, setCurrentTouchMove] = useState();
  const [trayHeight, setTrayHeight] = useState();
  const clickoutRef = useRef();
  const windowDims = useWindowSize(false);
  const transitions = useTransition(isVisible, {
    from: { y: '100%' },
    enter: { y: '0%' },
    leave: { y: '100%' },
    config: {
      duration: 500,
      easing: easings.easeOutCirc
    }
  });
  const bgAnimation = useSpring({
    opacity: backgroundOverlay && isVisible ? 1 : 0
  });

  useEffect(() => {
    if (!isVisible || !prevTouchMove.current || !currentTouchMove) {
      prevTouchMove.current = currentTouchMove;
      return;
    }
    const swipedDown = prevTouchMove.current < currentTouchMove;
    if (swipedDown) {
      setIsVisible(false);
    } else {
      prevTouchMove.current = currentTouchMove;
    }
  }, [currentTouchMove]);

  useEffect(() => {
    setTrayHeight('calc(100% - 32px)');
  }, [windowDims?.height]);

  return transitions(
    (styles, isVisible) => isVisible && (
      <animated.div
        ref={clickoutRef}
        style={{
          position: 'fixed',
          display: 'flex',
          alignItems: 'flex-end',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1030,
          backgroundColor: 'rgba(18,18,18, .5)',
          ...bgAnimation
        }}
        onClick={(e) => {
          if (e.target === clickoutRef.current) {
            setIsVisible(false);
          }
        }}
      >
        <animated.div
          className="relative flex"
          style={{
            ...styles,
            flex: 1,
            width: '100%',
            overflow: 'auto',
            backgroundColor: '#fff',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            height: trayHeight
          }}
        >
          {
            !hidePullTab &&
              <div
                className="absolute flex center middle responsive-padding"
                style={{
                  height: '36px',
                  top: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 100,
                  paddingRight: '1rem',
                  paddingLeft: '1rem'
                }}
                onTouchMove={(e) => {
                  const touch = e.touches && e.touches[0];
                  if (touch) {
                    setCurrentTouchMove(touch.clientY);
                  }
                }}
                onTouchEnd={() => {
                  setCurrentTouchMove(0);
                }}
              >
                <span
                  style={{
                    backgroundColor: '#D1D3DB',
                    width: '50px',
                    height: '4px',
                    borderRadius: '2px'
                  }}
                />
              </div>
          }
          <div className="flex flex-one column" style={{ marginTop: '40px' }}>
            {children}
          </div>
        </animated.div>
      </animated.div>
    )
  );
};
